import { render, staticRenderFns } from "../../templates/pwa/animalSearch.pug?vue&type=template&id=4b5b21f8&scoped=true&lang=pug&"
import script from "./animalSearch.vue?vue&type=script&lang=js&"
export * from "./animalSearch.vue?vue&type=script&lang=js&"
import style0 from "../../sass/pwa/animalSearch.sass?vue&type=style&index=0&id=4b5b21f8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b21f8",
  null
  
)

export default component.exports